import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
@Component({
  selector: 'app-view-animal-disease',
  templateUrl: './view-animal-disease.component.html',
  styleUrls: ['./view-animal-disease.component.css']
})
export class ViewAnimalDiseaseComponent implements OnInit {
  getanimaldiseaseviewApi:any;
  testdate:any;
  returnUrl="/dashboard/RottweilerDogsAnimalmanagement"
  constructor(private router: Router,private commonService: CommonService) { }

  async ngOnInit(){
    let DiseaseId = sessionStorage.getItem('diseaseId');
    this.getanimaldiseaseviewApi= "/animal_management/disease/"+DiseaseId;
    (await this.commonService.getApi(this.getanimaldiseaseviewApi)).subscribe(
      res => { 
        console.log(res.data);
        var date=res.data.tnam_dis_date_of_discovery;
         this.testdate = date.split('T');
        $("#DiseaseName").text(res.data.tnam_dis_disease_name),
        $("#DrugName").text(res.data.tnam_dis_drug_name),
        $("#dosevalue").text(res.data.tnam_dis_dose_value+" "+res.data.tnam_dis_units),
    //   $("#DiscoveryDate").text(res.data.tnam_dis_date_of_discovery),
       $("#Treatment").text(res.data.tnam_dis_treatment_given),
       $("#Description").text(res.data.tnam_dis_disease_description)
      })
  }
  RottweilerDogsAnimalmanagement(){

  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
